import { IIcons } from "app/lib/icons/icons";
import { Observable } from "rxjs";

export abstract class AbIcons{
  abstract setIcon(svg:string):Observable<any>;
}
